<template lang="pug">
.notification-row
  .notification(:class="notificationTypeClass")
    .notification-content.type-bold
      BriqIcon(:name="icon")
      span.pl-XXS {{ notification.message }}
</template>

<script>
import { mapActions } from 'vuex'
import { NotificationType } from '@v/store/notificationsModule'

export default {
  props: {
    notification: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      timeout: null,
    }
  },
  computed: {
    notificationTypeClass() {
      return `notification-${this.notification.type}`
    },
    icon() {
      if (this.notification.type === NotificationType.SUCCESS) return 'icon-input-checkbox-icon'
      if (this.notification.type === NotificationType.ERROR) return 'icon-cross-error-icon'
      if (this.notification.type === NotificationType.WARNING) return 'icon-cross-error-icon' // todo: use exclamation mark
      return ''
    },
  },
  methods: mapActions('notification', ['remove']),
  mounted() {
    this.timeout = setTimeout(() => this.remove(this.notification), 5000)
  },
  beforeDestroy() {
    clearTimeout(this.timeout)
  },
}
</script>

<style scoped lang="stylus">
.notification-row
  text-align center
  margin-bottom 12px

.notification
  color white
  font-weight bold
  padding 8px 16px
  border-radius 3px
  display inline-block
  margin auto

.notification-success
  background #3e9e00

.notification-error
  background #e93838

.notification-warning
  background #ff7901

.notification-content
  span
    position relative
    top 2px

  svg.icon
    font-size 10px
    fill white
    margin-right 5px
</style>
